import { createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../../../services/apiService/api/productSelectorApi";
import { PRODUCT_SELECTOR_FLOW_SLICE_NAME } from "../../sliceConstants";

const productSelectorThunkActions = {
  getProductListData: createAsyncThunk(
    `${PRODUCT_SELECTOR_FLOW_SLICE_NAME}/getProductListData`,
    async (payload, { rejectWithValue }) => {
      try {
        const response = await apiService.getProductListData(payload);
        return response || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getProductQuestion: createAsyncThunk(
    `${PRODUCT_SELECTOR_FLOW_SLICE_NAME}/getProductQuestion`,
    async (payload, { rejectWithValue }) => {
      try {
        const response = await apiService.getProductQuestion(payload);
        return response || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  postAnswerSubmit: createAsyncThunk(
    `${PRODUCT_SELECTOR_FLOW_SLICE_NAME}/postAnswerSubmit`,
    async (payload, { rejectWithValue }) => {
      try {
        const response = await apiService.postAnswerSubmit(payload);
        return response || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
};

export default productSelectorThunkActions;
